import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {DxDataGridComponent} from "devextreme-angular";
import * as _ from "lodash";
import {series} from "async";
import {ProdottoVariante} from "../../../models/ProdottoVariante";
import {Tessuto, TessutoFactory} from "../../../models/Tessuto";
import {Categoria, CategoriaFactory} from "../../../models/Categoria";
import {TessutoProdotto, TessutoProdottoFactory} from "../../../models/TessutoProdotto";
import {DialogService} from "../dialog/dialog.service";
import {DxService} from "../../../services/dx.service";
import {Colore, ColoreFactory} from "../../../models/Colore";
import {ServerService} from "../../../services/server.service";

@Component({
   selector: 'app-tab-category-composition',
   templateUrl: './tab-category-composition.component.html',
   styleUrls: ['./tab-category-composition.component.scss']
})
export class TabCategoryCompositionComponent implements OnInit, AfterViewInit {
   @Input() prodottoId;

   public vendorSlug;
   public categoriaProdottoId;
   public colorId;

   public tessuti:Tessuto[] = [];
   public categorie:Categoria[] = [];
   // public colori:Colore[] = [];
   public tessutiProdotto:TessutoProdotto[] = [];
   public catArray: any[] = [];

   public productVariant:ProdottoVariante = new ProdottoVariante({});
   public categoria?:Categoria = new Categoria({});


   public popupVisible: boolean = false;
   public tot_perc:number = 0;

   public composizioneFrm: UntypedFormGroup = new UntypedFormGroup({});
   public categoriaFrm: UntypedFormGroup = new UntypedFormGroup({});

   constructor(
      private tessutoFctr: TessutoFactory,
      private categoriaFctr: CategoriaFactory,
      private tessutoProdottoFctr: TessutoProdottoFactory,
      private dialog:DialogService,
      private dxSrv:DxService,
      private serverSrv: ServerService,
      private coloreFctr:ColoreFactory,
   ) {

      this.initComposizioneForm()
      this.initCategoriaForm()
   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      this.fecthData()
   }

   initComposizioneForm(){
      this.composizioneFrm = new UntypedFormGroup({
         composizioni: new UntypedFormArray([])
      })
   }

   initCategoriaForm(){
      this.categoriaFrm = new UntypedFormGroup({
         categories:new UntypedFormArray([])
      })
   }

   get composizioni() {
      return this.composizioneFrm.controls["composizioni"] as any;
   }

   get categorieArray() {
      return this.categoriaFrm.controls["categories"] as any;
   }

   fecthData(){
      if (this.prodottoId){
         series([
            (next: any) => {
               //fetchTessuti
               this.tessutoFctr.getTessuti(this.vendorSlug).then((tessuti) => {
                  this.tessuti = tessuti
                  this.fetchTessutiProdotto()
                  next(null)
               }).catch(err => {
                  console.error(err)
               })
            },
            (next: any) => {
               //fetchCategorie
               this.categoriaFctr.getCategorie(this.vendorSlug).then((categorie) => {
                  this.categorie = categorie
                  let c = _.filter(this.categorie, x => x.data.parent == null)
                  this.catArray.push(c)
                  next(null)
               }).catch(err => {
                  console.error(err)
               })
            },
            (next: any) => {
               //fetchCategoriaProdotto
               let cat = this.categoriaFrm.controls.categories as UntypedFormArray
               let url =
                  this.vendorSlug ?
                     `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/categorieprodotti` :
                     `/api/prodotti/${this.prodottoId}/categorieprodotti`
               this.serverSrv.get(null, url).then(res =>{
                  this.categoriaProdottoId = res.id
                  if (this.categoriaProdottoId){
                     let arr:any[] = []
                     this.categoria = _.find(this.categorie, x => x.data.id == res.categoria)
                     arr.push(this.categoria?.data.id!.toString())
                     while (this.categoria?.data.parent != null){
                        this.categoria = _.find(this.categorie, x => x.data.id == this.categoria?.data.parent)
                        arr.push(this.categoria?.data?.id!.toString())
                     }
                     let reversedArray = _.reverse(arr)

                     for (let i = 0; i < reversedArray.length; i++) {
                        this.setCategories(reversedArray[i], i+1)
                        cat.push(new UntypedFormGroup({
                           categoria: new UntypedFormControl(reversedArray[i]),
                           prodotto: new UntypedFormControl(this.prodottoId)
                        }))
                     }
                  } else {
                     cat.push(new UntypedFormGroup({
                        categoria: new UntypedFormControl(null),
                        prodotto: new UntypedFormControl(this.prodottoId)
                     }))
                  }
                  next(null)
               })
            },

         ],err => {
            if (err) {
               console.error("Impossibile andare avanti...")
               console.error(err)
            }
         })

         // this.dxSrv.initGrid(this.grid, {
         //    showAdd:true,
         //    onClickNew:()=>{
         //       this.productVariant = new ProdottoVariante({})
         //       this.colorId = null
         //       this.popupVisible = true
         //    }})
         // let url = this.vendorSlug ? `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/productvariants` : `/api/prodotti/${this.prodottoId}/productvariants`
         // this.dxSrv.gridCreateDataSource(url, this.grid, {})

         // this.fetchColori()

      }
   }

   fetchTessutiProdotto(){
      this.clearFormArrayTessuti(this.composizioneFrm.controls.composizioni)
      this.tessutoProdottoFctr.getTessutiProdotto(this.prodottoId, this.vendorSlug).then((tess_prod)=> {
         this.tessutiProdotto = tess_prod
         if (this.tessutiProdotto){
            this.patchValueTessutiProdotto()
         }
      }).catch(err => {
         console.error(err)
      })
   }

   clearFormArrayTessuti = (formArray) => {
      while (formArray.length !== 0) {
         formArray.removeAt(0)
      }
   }

   clickSaveCategoria() {
      if (this.categoriaFrm.invalid){
         this.categoriaFrm.markAllAsTouched()
         this.dialog.showError({title:"Attenzione!", err:"Non hai completato la selezione della categoria."})
         return
      }
      let url = this.vendorSlug ?
         `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/categorieprodotti` :
         `/api/prodotti/${this.prodottoId}/categorieprodotti`
      this.serverSrv.post(url,
         this.categoriaFrm.value.categories[this.categoriaFrm.value.categories.length - 1]).then(res => {
         this.dialog.showSuccess({title:'Categoria salvata', msg:'Categoria salvata con successo'})
      }).catch(err => {
         console.error(err)
         this.dialog.showError({title:'Errore!', err:err})
      })
   }

   setCategories(value, i){
      let c = _.filter(this.categorie, x => x.data.parent == value)
      if (c.length > 0) {
         this.catArray.splice(i, this.catArray.length)
         this.catArray.push(c)
      }
   }

   patchValueTessutiProdotto(){
      let comp = this.composizioneFrm.controls.composizioni as UntypedFormArray
      for (let i in this.tessutiProdotto){
         comp.push(new UntypedFormGroup({
            id: new UntypedFormControl(this.tessutiProdotto[i].data.id),
            tessuto: new UntypedFormControl(this.tessutiProdotto[i]?.data?.tessuto?.toString(), Validators.required),
            percentuale: new UntypedFormControl(this.tessutiProdotto[i].data.percentuale, Validators.required),
            prodotto: new UntypedFormControl(this.prodottoId)
         }))
      }
      this.changePerc()
   }

   changePerc() {
      this.tot_perc = 0
      for (let i = 0; i < this.composizioni.length; i++) {
         this.tot_perc = this.tot_perc + this.composizioni.controls[i].value.percentuale
      }
      if (this.tot_perc < 100) this.addRow()
      if (this.tot_perc > 100) this.dialog.showError({title:"Attenzione!", err:"La percentuale totale della composizione è maggiore del 100%"})
   }

   addRow() {
      let comp = this.composizioneFrm.controls.composizioni as UntypedFormArray
      if (this.composizioni.controls.slice(-1)[0]?.value.percentuale != ''){
         comp.push(new UntypedFormGroup({
            id: new UntypedFormControl(null),
            tessuto: new UntypedFormControl('', Validators.required),
            percentuale: new UntypedFormControl('', Validators.required),
            prodotto: new UntypedFormControl(this.prodottoId)
         }))
      }
   }

   clickSaveComposizione() {
      this.composizioni.markAllAsTouched()
      if (this.composizioni.invalid){
         this.dialog.showError({err:"Attenzione, non hai inserito tutti i dati."})
         return;
      }
      this.tessutoProdottoFctr.postTessutoProdotto(this.prodottoId, this.composizioneFrm.value, this.vendorSlug).then(res => {
         this.fetchTessutiProdotto()
         this.dialog.showSuccess({msg:"Composizioni salvate."})
      }).catch(err =>  {
         console.error(err)
      })
   }

   clickChangeCategories(value, i){
      let c = _.filter(this.categorie, x => x.data.parent == value)
      for (let j = this.catArray.length; j > i; j--) {
         this.categorieArray.removeAt(j - 1)
      }
      this.catArray.splice(i, this.catArray.length)
      if (c.length > 0) {
         let cat = this.categoriaFrm.controls.categories as UntypedFormArray
         this.catArray.push(c)
         cat.push(new UntypedFormGroup({
            categoria: new UntypedFormControl(null, Validators.required),
            prodotto: new UntypedFormControl(this.prodottoId)
         }))
      }
   }

   clickEliminaFormGroup(i:any, composizione) {
      if (composizione.value.id){
         this.dialog.showConfirm({title:"Elimina Composizione", msg:"Vuoi davvero eliminare questa composizione?"}).then(() => {
            this.tessutoProdottoFctr.deleteTessutoProdotto(this.prodottoId, composizione.value.id).then(() => {
               this.composizioni.removeAt(i)
               setTimeout(()=> {
                  this.changePerc()
               },1000)
            }).catch(err => {
               console.error(err)
            })
         }).catch(err => {})
      } else{
         this.composizioni.removeAt(i)
         setTimeout(()=> {
            this.changePerc()
         },1000)
      }
   }

   clickEditCategoria() {
      if (this.categoriaFrm.invalid){
         this.categoriaFrm.markAllAsTouched()
         this.dialog.showError({title:"Attenzione!", err:"Non hai completato la selezione della categoria."})
         return
      }
      this.serverSrv.put(`/api/prodotti/${this.prodottoId}/categorieprodotti/${this.categoriaProdottoId}`,
         this.categoriaFrm.value.categories[this.categoriaFrm.value.categories.length - 1]).then(res => {
         this.dialog.showSuccess({title:'Categoria modificata', msg:'Categoria modificata con successo'})
      }).catch(err => {
         console.error(err)
         this.dialog.showError({title:'Errore!', err:err})
      })
   }

   // fetchColori(){
   //    this.coloreFctr.getColori(this.vendorSlug).then((colori) => {
   //       this.colori = colori
   //    }).catch(err => {
   //       console.error(err)
   //    })
   // }

}
